import type { UpdateUserSettingsData } from '../schemas/user-settings.schema';

interface ErrorResponse {
  error: string;
}

export interface UserSettingsResponse {
  id: string;
  userId: string;
  displayName: string | null;
  firstName: string | null;
  lastName: string | null;
  gender: string | null;
  handicap: string | null;
  homeClub: string | null;
  nationality: string | null;
  unitDistance: string | null;
  unitSpeed: string | null;
  timezone: string | null;
  startOfWeek: string | null;
  preferredLanguage: string | null;
  avatarUrl: string | null;
  contactNameFormat: string | null;
  updatedAt: string;
}

interface CountryRecord {
  countryCode: string;
  name: string;
}

interface CountriesResponse {
  countries: CountryRecord[];
}

export async function fetchUserSettings(): Promise<UserSettingsResponse> {
  const response = await fetch('/api/user-settings');
  if (!response.ok) {
    const error = (await response.json()) as ErrorResponse;
    throw new Error(error.error ?? 'Failed to fetch user settings');
  }
  return response.json() as Promise<UserSettingsResponse>;
}

export async function patchUserSettings(data: UpdateUserSettingsData): Promise<UserSettingsResponse> {
  const response = await fetch('/api/user-settings', {
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  });
  if (!response.ok) {
    const error = (await response.json()) as ErrorResponse;
    throw new Error(error.error ?? 'Failed to update user settings');
  }
  return response.json() as Promise<UserSettingsResponse>;
}

export async function fetchCountries(): Promise<CountriesResponse> {
  const response = await fetch('/api/countries');
  if (!response.ok) {
    const error = (await response.json()) as ErrorResponse;
    throw new Error(error.error ?? 'Failed to fetch countries');
  }
  return response.json() as Promise<CountriesResponse>;
}
